
import Lastmenu2 from './LastMenu2';
import you from '../images/boy.png';
import bot from '../images/happy.png';
import { useState } from 'react';

const Contact = () => {
    const [time] =useState(new Date());
return(
    <>
     <div className="you-time animated-frame">
            <img src={you} alt="boy" className="boy" />
            You {time?.toLocaleTimeString()}</div>
          <div className="you-message">
            <div className="frame2 animated-frame"><b>Contact Us</b></div>
          </div>

          <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
          </div>
    <div className="frame1 animated-frame" >
        
        <div className="box1">
            <h6>Contact Us</h6><br></br>
           <b> Dodla Dairy Limited:</b><br></br>
# 8-2-293/82/A, 270/Q, Road No 10-C, Jubilee Hills,
Hyderabad – 500 033, Telangana, India.<br></br>
<b>Map:</b><br></br>
<a href='https://maps.app.goo.gl/WJWvGfQtzhD6Ncrx8'>Click Here</a><br></br>
<b>Phone</b><br></br>
040-4546 7777 <br></br>

<b>Fax:</b><br></br>
040-4546 7788 <br></br>

<b>E-mail</b><br></br>
mail@dodladairy.com
        </div>
    </div>
    <Lastmenu2 />
    </>
);
}
export default Contact;
